module.exports = __webpack_public_path__ + "img/play_text_bottom.80b440db.png";